export default {
  namespaced: true,
  state: {
    mostradoDetalleSolicitudesPagos: JSON.parse(localStorage.getItem('mostradoDetalleSolicitudesPagos')) || false,
    mostradoDetalleSolicitudesPagosAgrupados:
      JSON.parse(localStorage.getItem('mostradoDetalleSolicitudesPagosAgrupados')) || false,
  },
  mutations: {
    setMostradoDetalleSolicitudesPagos(state, value) {
      state.mostradoDetalleSolicitudesPagos = value;

      localStorage.setItem('mostradoDetalleSolicitudesPagos', value);
    },
    setMostradoDetalleSolicitudesPagosAgrupados(state, value) {
      state.mostradoDetalleSolicitudesPagosAgrupados = value;

      localStorage.setItem('mostradoDetalleSolicitudesPagosAgrupados', value);
    },
  },
  actions: {
    setMostradoDetalleSolicitudesPagos({ commit }, value) {
      commit('setMostradoDetalleSolicitudesPagos', value);
    },
    setMostradoDetalleSolicitudesPagosAgrupados({ commit }, value) {
      commit('setMostradoDetalleSolicitudesPagosAgrupados', value);
    },
  },
  getters: {
    getMostradoDetalleSolicitudesPagos: (state) => state.mostradoDetalleSolicitudesPagos,
    getMostradoDetalleSolicitudesPagosAgrupados: (state) => state.mostradoDetalleSolicitudesPagosAgrupados,
  },
};
